//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import StreamsDrawerAssetFeedsSetupModal from '@streams/components/StreamsDrawerAssetFeedsSetupModal';

angular.module('curalate').component('streamsDrawerAssetFeedsSetupModal', {
  controller: makeAngularReactController(<StreamsDrawerAssetFeedsSetupModal/>),
});
